<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.qualitative_reports', 2),
                        href: null,
                    },
                    {
                        name: group.name,
                        href: meta.links.group_show,
                    },
                    {
                        name: student.full_name,
                        href: meta.links.student_index,
                    },
                    {
                        name: record.date,
                        href: meta.links.show,
                    },
                    {
                        name: $t('messages.edit'),
                        href: null,
                    },
                ]"
            />
        </template>

        <UnsavedChangesFormWarning :is-dirty="form.isDirty" v-if="form.isDirty" />
        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <div class="mt-5">
                <div
                    v-for="qualitativeReportCategory in form.qualitativeReportCategories"
                    :key="qualitativeReportCategory.id"
                >
                    <div class="flex justify-between">
                        <span class="font-semibold">
                            {{ qualitativeReportCategory.category_order }} -
                            {{ qualitativeReportCategory.title }}
                        </span>
                        <div class=""></div>
                    </div>
                    <div class="bg-gray-100 overflow-hidden rounded-lg mt-3">
                        <div class="px-4 py-5 sm:p-6">
                            <div class="flex flex-col mt-5" v-if="qualitativeReportCategory.subcategories.length > 0">
                                <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                                    <div
                                        class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                                    >
                                        <table class="min-w-full divide-y divide-gray-200">
                                            <template
                                                v-for="subcategory in qualitativeReportCategory.subcategories"
                                                :key="`${subcategory.id}_${subcategory.updated_at}`"
                                            >
                                                <thead>
                                                    <tr class="uppercase">
                                                        <th
                                                            class="max-w-xs px-6 py-3 bg-gray-200 text-left text-xs leading-4 font-medium text-gray-700 tracking-wider"
                                                        >
                                                            {{ subcategory.name }}
                                                            (
                                                            {{ subcategory.grade_levels_display }}
                                                            )
                                                        </th>
                                                        <th
                                                            v-for="gradation in qualitativeReportCategory.gradation"
                                                            :key="gradation.value"
                                                            class="max-w-xs px-6 py-3 bg-gray-200 text-center text-xs leading-4 font-medium text-gray-700 uppercase tracking-wider"
                                                        >
                                                            <button
                                                                type="button"
                                                                @click="setValue(subcategory, gradation.value)"
                                                                class="uppercase"
                                                            >
                                                                {{ gradation.text }}
                                                            </button>
                                                        </th>
                                                    </tr>
                                                    <tr
                                                        :class="index % 2 === 0 ? 'bg-white' : 'bg-gray-50'"
                                                        v-for="(item, index) in subcategory.items"
                                                        :key="`${item.id}_${item.updated_at}`"
                                                    >
                                                        <td
                                                            class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500"
                                                        >
                                                            {{ item.name }}
                                                        </td>
                                                        <td
                                                            v-for="gradation in qualitativeReportCategory.gradation"
                                                            :key="gradation.value"
                                                            class="px-6 py-4 text-center whitespace-nowrap text-sm leading-5 text-gray-500 cursor-pointer border-l border-gray-100"
                                                            @click="item.value = gradation.value"
                                                        >
                                                            <input
                                                                v-model="item.value"
                                                                type="radio"
                                                                :name="`item_${item.id}`"
                                                                :value="gradation.value"
                                                                class="focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300"
                                                            />
                                                        </td>
                                                    </tr>
                                                </thead>
                                            </template>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="flex justify-end mt-5">
                <SubmitFormButton :button-text="$t('messages.save')" :processing="form.processing" />
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import UnsavedChangesFormWarning from '@/components/Forms/UnsavedChangesFormWarning.vue';
import SubmitFormButton from '@/Pages/Teacher/Activities/Subactivities/SubmitFormButton.vue';

export default {
    components: {
        SubmitFormButton,
        UnsavedChangesFormWarning,
        PanelPage,
    },
    layout: Layout,
    name: 'Create',
    props: ['meta', 'qualitativeReportCategories', 'filters', 'student', 'group', 'record'],
    data() {
        return {
            form: this.$inertia.form({
                qualitativeReportCategories: this.qualitativeReportCategories,
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
        setValue(subcategory, value) {
            subcategory.items.forEach((item) => {
                if (item.value === null) {
                    item.value = value;
                }
            });
        },
    },
};
</script>
